export default __webpack_public_path__ + "static/media/blog25.d85c52ac.jpg";